export const violationsTypes = {
  "violationsTypes.get": "violationsTypes.get",
  "violationsTypes.delete": "violationsTypes.delete",
  "violationsTypes.create": "violationsTypes.create",
  "violationsTypes.edit": "violationsTypes.edit",
  "violationsTypes.changeStatus": "violationsTypes.changeStatus",
} as const;
